(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-brand-nav"] && !Shopify.designMode) return;
  try {
    
  class FooterBrandNav extends HTMLElement {
    connectedCallback() {
      this.#groups = [...this.querySelectorAll('details')];
      this.#mql = window.matchMedia('(min-width: 1000px)');
      this.#sync = () => {
        this.#groups.forEach((group) => {
          group.open = this.#mql.matches;
        });
      };
      this.#sync();
      this.#mql.addEventListener('change', this.#sync);
    }

    disconnectedCallback() {
      this.#mql?.removeEventListener('change', this.#sync);
    }

    #groups = [];
    #mql = null;
    #sync = null;
  }

  if (!customElements.get('footer-brand-nav')) {
    customElements.define('footer-brand-nav', FooterBrandNav);
  }

  const loadFooterReviewsRibbon = () => {
    if (window.__footerNlReviewsInit) return;

    const badge = document.querySelector('[id^="FooterBadgeRibbon-"]');
    if (!badge) return;

    window.__footerNlReviewsInit = true;

    const start = () => {
      if (typeof reviewsBadgeRibbon !== 'function') {
        window.setTimeout(start, 80);
        return;
      }

      reviewsBadgeRibbon(badge.id, {
        store: 'nordleaf.de',
        size: 'small',
        mono: true,
      });
    };

    if (typeof reviewsBadgeRibbon === 'function') {
      start();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://widget.reviews.io/badge-ribbon/dist.js';
    script.addEventListener('load', start);
    document.head.appendChild(script);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadFooterReviewsRibbon, { once: true });
  } else {
    loadFooterReviewsRibbon();
  }

  } catch(e) { console.error(e); }
})();
})();
